export const couriersCashShipmentCollectionGuard =
  'GET /couriers-cash/shipments';
export const courierCashShipmentsEmployeeCollectionGuard =
  'GET /couriers-cash/shipments/employees';
